<template>
  <p class="caption">
    <slot />
  </p>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.caption {
  font-size: 12px;
}
</style>